<template>
  <div class="replacementstatistics__report__view">
    <div class="reports__subheader">
      <period-panel :dateFrom="dateFrom"
                    :dateTo="dateTo"
                    @dateFrom="(value) => this.dateFrom = value"
                    @dateTo="(value) => this.dateTo = value">
      </period-panel>

      <region-panel :region="region"
                    @region="(value) => this.region = value">
      </region-panel>

      <submit-panel @submit="performLookup">
      </submit-panel>
    </div>

    <b-table :data="replacementReportForPeriod"
             :loading="loading"
             default-sort="number"
             hoverable>

      <b-table-column field="number" label="Ins. nr." v-slot="props" sortable numeric>
          {{ props.row.number }}
      </b-table-column>

      <b-table-column field="name" label="Inseminør" v-slot="props" sortable>
          {{ props.row.name }}
      </b-table-column>

      <b-table-column field="weekday" label="Arbejde" v-slot="props">
          {{ props.row.weekday }}
      </b-table-column>

      <b-table-column field="saturday" label="Arbejde lørdag" v-slot="props">
          {{ props.row.saturday }}
      </b-table-column>

      <b-table-column field="sunday" label="Arbejde søndag" v-slot="props">
          {{ props.row.sunday }}
      </b-table-column>

      <b-table-column field="vacation" label="Ferie" v-slot="props">
          {{ props.row.vacation }}
      </b-table-column>

      <b-table-column field="id" label="#" v-slot="props">
        <router-link :to="{ name: 'MonthlyStatistics', params: { employeeNumber: props.row.number }}">Månedsrapport</router-link>
      </b-table-column>

    </b-table>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import  APISTATE from '@/enums/APISTATE';
import PeriodPanel from '@/components/report/PeriodPanel.vue';
import RegionPanel from '@/components/report/RegionPanel.vue';
import SubmitPanel from '@/components/report/SubmitPanel.vue';

export default {
  name: "replacementstatistics-report-view",
  components: { PeriodPanel, RegionPanel, SubmitPanel },
  data: () => ({
    dateFrom: undefined,
    dateTo: undefined,
    region: undefined,
  }),
  async mounted() {
    this.dateFrom = new Date(new Date().getFullYear(), 0, 1);
    this.dateTo = new Date(new Date().getFullYear(), 11, 31);
  },
  methods: {
    ...mapActions('reportStore', ['getReplacementReportForPeriod']),
    async performLookup() {
      if ((this.dateFrom) && (this.dateTo)) {
        const model = { startDate: this.dateFrom, endDate: this.dateTo, forRegion: this.region };
        await this.getReplacementReportForPeriod(model);
      }
    }
  },
  computed: {
    ...mapGetters('reportStore', ['replacementReportForPeriodApiState', 'replacementReportForPeriod']),
    loading() {
      return this.replacementReportForPeriodApiState === APISTATE.LOADING;
    }
  },

}
</script>

<style lang="scss">

</style>